import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormFieldWidgetType } from "@app/forms/enums/FormFieldWidgetTypes";
import { FormField, FormFieldConfig } from "@app/forms/models";
import { parseTyped } from "@methods/CommonMethods";
import { MatrixCell } from "@models/generic/MatrixModel";
import { CerrixRiskMatrixComponent } from "@app/shared/components/cerrix-riskmatrix/cerrix-riskmatrix.component";

@Component({
    selector: "form-entry-widget",
    templateUrl: "./form-entry-widget.component.html",
    imports: [CerrixRiskMatrixComponent]
})
export class FormEntryWidgetComponent implements OnInit {
    @Input() field: FormField;
    @Input() answer: string;
    @Input() readonly: boolean;
    @Output() answerChange: EventEmitter<string> = new EventEmitter<string>();

    widgetTypes = FormFieldWidgetType;
    widgetSettings: FormFieldConfig;

    riskMatrixAnswer: MatrixCell;

    ngOnInit() {
        this.widgetSettings = parseTyped<FormFieldConfig>(this.field.CustomSettings, new FormFieldConfig());

        if (this.widgetSettings.widgetType === FormFieldWidgetType.RiskMatrix) {
            this.riskMatrixAnswer = parseTyped<MatrixCell>(this.answer, new MatrixCell());
        }
    }

    emitChange() {
        if (this.widgetSettings.widgetType === FormFieldWidgetType.RiskMatrix) {
            this.answer = JSON.stringify(this.riskMatrixAnswer);
        }

        this.answerChange.emit(this.answer);
    }
}
